import {createContext} from 'react';
const SignupDetailsContext = createContext();
export default SignupDetailsContext;
